export default __webpack_public_path__ + "static/media/logo-app-store.9e0260d1.svg";